import axios from '../axios';
import instantMeiliSearch from '@meilisearch/instant-meilisearch';

/**
 * Client Factory
 * @type {Map<String, Function>}
 */
const clients = new Map();

clients.set('default', (config) => ({
    async search(requests) {
        if (this.controller) {
            this.controller.abort();
            this.controller = null;
        }

        this.controller = new AbortController();

        return await axios.post(config.url ?? window.config.urls.search.api, {requests}, {
            signal: this.controller.signal,
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(response => response?.data ?? []);
    }
}));

clients.set('meilisearch', (config) => {
    return instantMeiliSearch(
        config.host,
        config.key
    );
});

export default clients;
